import { render, staticRenderFns } from "./DonationLists.vue?vue&type=template&id=a5c87384"
import script from "./DonationLists.vue?vue&type=script&lang=js"
export * from "./DonationLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports